import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaDraftDTO, RmaDraftDTO } from 'components/ordering/rma/api/dtos/rma-draft-dto.js'

export class FetchRmaDraft extends RmaRequest<RmaDraftDTO | null, never> {
  path = 'account/rma/draft/fetch/'

  override parseResponse = (data: unknown) => parseRmaDraftDTO(data)
}
